module.exports = __webpack_public_path__ + "static/media/SXP.3b91904b.svg";